import React, { useEffect } from 'react';
import SectionWithTitle from '../../components/SectionWithTitle';
import SectionWithTitleContent from '../../components/SectionWithTitleContent';
import IconWithTitle from '../../components/IconWithTitle';
import IconWithDescription from '../../components/IconWithDescription';

import './styles.css';

import sections from './data';

const Courses = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {sections.map((section, index) => {
        return (
          <div key={index}>
            {/* {console.log('test')} */}
            <SectionWithTitle
              title={section.title}
              children={
                <SectionWithTitleContent
                  content={section.content.map(content => (
                    <IconWithDescription
                      path={content.path}
                      name={content.name}
                      description={content.description}
                      link={content.link}
                    ></IconWithDescription>
                  ))}
                />
              }
            />
          </div>
        );
      })}
    </div>
  );
};

export default Courses;
